"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck } from "lucide-react";
const FinancialTicker = () => {
  const tickerItems = ["ALGORITHMIC EXECUTION", "AUTOMATED RISK MANAGEMENT", "NO MANUAL INTERVENTION", "DATA-DRIVEN STRATEGIES", "LOW-LATENCY EXECUTION", "BACKTESTED MODELS", "TRANSPARENT PERFORMANCE", "SECURE INFRASTRUCTURE", "24/5 MARKET MONITORING"];
  const items = [...tickerItems, ...tickerItems, ...tickerItems];
  return <div data-section-id="17922" className="absolute top-0 left-0 w-full overflow-hidden opacity-60 pointer-events-none z-0 select-none border-b border-white/10 bg-background/80 backdrop-blur-md">
      <div className="flex whitespace-nowrap py-3">
        <div className="flex gap-12 animate-ticker" style={{
        animation: "ticker 60s linear infinite",
        width: "max-content"
      }}>
          {items.map((item, i) => <span key={i} data-index={i} className="text-sm font-mono text-white/80 tracking-widest uppercase">
              {item}
            </span>)}
        </div>
      </div>
      <style jsx>{`
        @keyframes ticker {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.33%);
          }
        }
      `}</style>
    </div>;
};
const ShieldSketch = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (!isMounted) return <div className="w-full h-full flex items-center justify-center text-muted-foreground/20">Initializing Engine...</div>;
  return <div className="w-full h-[400px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="relative w-full h-full flex items-center justify-center">
        
        <div className="absolute inset-0 flex items-center justify-center perspective">
          
          <div className="relative w-48 h-56 animate-pulse" style={{
          animation: "shieldRotate 8s linear infinite"
        }}>
            
            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 200 240" preserveAspectRatio="xMidYMid meet">
              <defs>
                <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{
                  stopColor: "rgb(180, 210, 255)",
                  stopOpacity: 0.6
                }} />
                  <stop offset="100%" style={{
                  stopColor: "rgb(14, 165, 233)",
                  stopOpacity: 0.3
                }} />
                </linearGradient>
              </defs>
              <path d="M 100 10 L 160 50 L 160 120 Q 100 180 100 180 Q 100 180 40 120 L 40 50 Z" fill="url(#shieldGradient)" stroke="rgb(14, 165, 233)" strokeWidth="2" />
            </svg>

            
            {[0, 1, 2, 3, 4, 5].map(i => <div key={i} className="absolute w-8 h-8 bg-gradient-to-br from-sky-400 to-sky-600 opacity-40 rounded-sm" style={{
            animation: `shardFloat ${3 + i * 0.5}s ease-in-out infinite`,
            left: `${50 + Math.cos(i / 6 * Math.PI * 2) * 80}px`,
            top: `${50 + Math.sin(i / 6 * Math.PI * 2) * 80}px`,
            transform: `rotate(${i * 60}deg)`
          }} />)}
          </div>

          
          <div className="absolute w-96 h-96 bg-gradient-to-r from-sky-500/20 via-cyan-500/10 to-blue-500/20 rounded-full blur-3xl animate-pulse" />
        </div>
      </div>

      <style jsx>{`
        @keyframes shieldRotate {
          0% {
            transform: rotateY(0deg) rotateX(0deg);
          }
          100% {
            transform: rotateY(360deg) rotateX(5deg);
          }
        }
        @keyframes shardFloat {
          0%, 100% {
            transform: translateY(0) rotate(0deg) scale(1);
            opacity: 0.3;
          }
          50% {
            transform: translateY(-20px) rotate(180deg) scale(1.2);
            opacity: 0.6;
          }
        }
        .perspective {
          perspective: 1000px;
        }
      `}</style>
    </div>;
};
export default function TheEuropeanStandardInAssetSafeguarding() {
  return <section id="institutional-trading-precision" className="dark bg-background text-foreground relative w-full min-h-[90vh] flex flex-col overflow-hidden">
      
      <FinancialTicker />

      
      <div className="container mx-auto px-4 md:px-6 flex-1 flex flex-col md:flex-row items-center justify-center relative z-10 pt-20 pb-12 md:pt-0 md:pb-0">
        
        
        <div className="w-full md:w-3/5 flex flex-col justify-center space-y-8 md:pr-12 text-center md:text-left">
          
          
          <div className="inline-flex items-center justify-center md:justify-start gap-2 text-primary/80 font-mono text-xs tracking-widest uppercase animate-fade-in">
            <ShieldCheck className="w-4 h-4" />
            <span>Institutional Grade Execution</span>
          </div>

          
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter leading-[1.1] md:leading-[1.1]">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-zinc-100 via-zinc-400 to-zinc-600">Algorithmic Precision.</span>
            <br />
            <span className="text-foreground">
              Retail Accessibility.
            </span>
          </h1>

          <div className="flex flex-row items-center justify-center gap-5 pb-9 opacity-75">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582830/img/image_7ur39zyo.png" alt="Sierra Chart" className="max-h-[60px] object-contain" />
            <div className="w-[150px] h-[75px] flex items-center justify-center">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582830/img/image_czx5lnaw.png" alt="MetaTrader 5" className="h-[75px] object-contain" />
            </div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582830/img/image_h1rajpz2.png" alt="PU Prime" className="max-h-[60px] object-contain" />
          </div>

          
          <p className="font-sans text-muted-foreground text-sm md:text-base lg:text-lg max-w-2xl mx-auto md:mx-0 leading-relaxed border-l-2 border-primary/40 pl-6">Imperium Technologies provides clients with access to a disciplined copytrading service built around algorithmic execution, structured risk logic, and professional onboarding.</p>

          
          <div className="flex flex-col sm:flex-row gap-4 pt-4 items-center md:items-start justify-center md:justify-start">
            <Button asChild size="lg" className="h-14 px-8 text-base font-semibold bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_25px_rgba(14,165,233,0.4)] transition-all duration-300 hover:scale-105">
              <Link to="/access/?imp_tab=register">
                Start Copying
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
            
            <Button asChild variant="ghost" size="lg" className="h-14 px-8 text-base font-mono text-muted-foreground hover:text-foreground hover:bg-white/5 border border-zinc-800 hover:border-zinc-700 transition-all duration-300">
              <Link to="/BacktestResultsPage">View Backtest Results</Link>
            </Button>
          </div>

          
        </div>

        
        <div className="w-full md:w-2/5 h-[50vh] md:h-auto flex items-center justify-center relative mt-12 md:mt-0">
          
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-primary/10 blur-[100px] rounded-full pointer-events-none" />
          
          
          <div className="w-full h-full relative z-10">
            <ShieldSketch />
          </div>
        </div>

      </div>

      
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-background to-transparent pointer-events-none z-20" />
    </section>;
}